module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-column"
  }, [_c('div', {
    staticClass: "w-100 pa3 flex items-center"
  }, [_vm._t("icon", function() {
    return [_c('akko-plan-icon', {
      attrs: {
        "alt": "AKKO Plan",
        "height": "60",
        "width": "60"
      }
    })]
  }), _vm._v(" "), _c('div', {
    staticClass: "ml3"
  }, [_c('h5', {
    staticClass: "db cera-round-pro f5 pv2"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "cera-round-pro grey-font pv2"
  }, [_vm._v("\n        " + _vm._s(_vm.subHeading) + "\n      ")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "pa4 upgrade-info-container details-grey-font inter"
  }, [_c('div', {
    staticClass: "flex flex-column"
  }, [_c('div', {}, [_c('span', {
    staticClass: "cera-med db mv2 f5 fw1 black"
  }, [_vm._v("\n          What's Included?\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "db mv2 f5 fw4"
  }, [_vm._v("\n          " + _vm._s(_vm.planBenefitsSummary) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-wrap f5 pt2 mb2"
  }, _vm._l((_vm.planBenefitsLineItems), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "w-50-ns w-100 mb3 flex items-center fw5"
    }, [_c('img', {
      staticClass: "pr2",
      attrs: {
        "alt": "✓",
        "height": "14",
        "src": "/static/appicons/Check.svg"
      }
    }), _vm._v(" "), _c('span', [_vm._v("\n            " + _vm._s(item) + "\n          ")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between bt b--light-silver pt3 items-center"
  }, [_c('div', [_c('span', {
    staticClass: "cera-med fw5 f3"
  }, [_vm._v("\n            " + _vm._s(_vm.priceIncrease) + "\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "inter fw6"
  }, [_vm._v("\n            " + _vm._s(_vm.paymentFrequency) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "fw6 inter"
  }, _vm._l((_vm.deductibleItems), function(deductibleItem, index) {
    return _c('div', {
      key: index,
      staticClass: "tr"
    }, [_vm._v("\n            " + _vm._s(deductibleItem) + "\n          ")])
  }), 0)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e02128","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/add-plan/PlanUpgradeCard.vue
// module id = 1316
// module chunks = 0